import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { MembroUnidadeDTO } from 'model/reino/MembroUnidadeDTO';
import { MembroUnidadeGetAllItemDTO } from 'model/reino/MembroUnidadeGetAllItemDTO';
import { Api } from 'service/api/Api';
import { ApiMembrosUnidade } from 'service/api/reino/ApiMembrosUnidade';
import { ResponseError } from 'view/component/MensagensErroServidor/ErroServidor.utils';

interface MembroUnidadeState {
  data: MembroUnidadeDTO[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error?: ResponseError;
  membroUnidade: any | null;
}

const initialState: MembroUnidadeState = {
  data: [],
  status: 'idle',
  error: undefined,
  membroUnidade: null,
};

export const fetchMembrosUnidades = createAsyncThunk('membroUnidade/fetchMembrosUnidades', async () => {
  return await ApiMembrosUnidade.getAllByReino(1);
});


export const addMembroUnidade = createAsyncThunk('membroUnidade/addMembroUnidade', async (membroUnidade: MembroUnidadeDTO) => {
  return await ApiMembrosUnidade.adicionar(membroUnidade);
});

export const updateMembroUnidadeById = createAsyncThunk('membroUnidade/updateMembroUnidade', async (membroUnidade: MembroUnidadeDTO) => {
  return await ApiMembrosUnidade.atualizar(membroUnidade.id ?? 0, membroUnidade);
});

const membroUnidadeSlice = createSlice({
  name: 'membroUnidade',
  initialState,
  reducers: {
    setCurrentMembroUnidade: (state, action: PayloadAction<any>) => {
      state.membroUnidade = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMembrosUnidades.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchMembrosUnidades.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        console.log(action.payload);
      })
      .addCase(fetchMembrosUnidades.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message as ResponseError;
        console.log('fetchMembrosUnidades.rejected', action.error.message);
      })
      .addCase(addMembroUnidade.fulfilled, (state, action) => {
        state.data.push(action.payload);
      })
      .addCase(updateMembroUnidadeById.fulfilled, (state, action) => {
        const index = state.data.findIndex((item) => item.id === action.payload.id);
        state.data[index] = action.payload;
      })
  },
});

export default membroUnidadeSlice.reducer;

